import { render, staticRenderFns } from "./VStarIcon.vue?vue&type=template&id=17dd9dc8"
import script from "./VStarIcon.vue?vue&type=script&lang=js"
export * from "./VStarIcon.vue?vue&type=script&lang=js"
import style0 from "./VStarIcon.vue?vue&type=style&index=0&id=17dd9dc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports